export enum CPTType {
  ELICITED = 'ELICITED',
  CALCULATED = 'CALCULATED'
}
